export const vmBreached = (mtmPercentage?: number, variationMargin?: number) => {
  if (mtmPercentage === undefined || variationMargin === undefined) return false;
  return mtmPercentage < 0 && mtmPercentage < -variationMargin;
};

export default vmBreached;
